<script>
  import { setContext } from 'svelte';
  import ViewIcon from './ViewIcon.svelte';
  import VenueLogo from './VenueLogo.svelte';
  import DateTime from './DateTime.svelte';

  export let app;
  setContext('app', app);
</script>

<ViewIcon />
<VenueLogo />
<DateTime />
